import React, { useState, useEffect, useContext } from "react";
import BasicSelect from "../select/select";
import TopBar from "../../scenes/global/Top-Bar";
import { TextArea } from "../textarea/textarea";
import SideBar from "../../scenes/global/Side-Bar";
import Tab from "../tab/tab";
import { useDispatch, useSelector } from "react-redux";
import { dispatchAward, saveAward } from "../../Redux/ActionCreator";
import AddedItem from "../added_item/added_item";
import AddMore from "../add_more/add_more";
import $ from 'jquery';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../scenes/global/languageContext";
import dayjs from "dayjs";


export default function UserAwardAndHonor(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const existingCv = useSelector(e => e.existingCV);
  const message = existingCv.message;
  const award_data = useSelector(awd => awd.award)
  let [chips, setChips] = useState([]);
  const generated = useSelector(e => e.generateCV);
  const profile1 = useSelector(e => e.login);
  let stat = profile1.profile_status.profile_status;
  const secret = useSelector(prev => prev.secret);
  const cv = useSelector(prev => prev.cvId);
  const userInfo = useSelector(e => e.userInfo);
  let [ award, setaward ] = useState([]);
  const [ awardYear, setAwardYear ] = useState("");
  const [ obj, setObj ] = useState()

  useEffect(() => {
    if (typeof props.award === "string") {
      setChips([props.award]);
      setaward([props.award]);
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname === `/form/${cv.id}/update`) {
      console.log("got here")
      if (generated.message?.Award !== null) {
        setChips(generated.message?.Award);
        setaward(generated.message?.Award);
      }
    } else {
      if (award_data.award !== null) {
        setChips(award_data.award);
        setaward(award_data.award);
      } else if (message !== null) {
         if (message.Award === "" || message.Award == null) {
          chips = [];
          award = [];
          console.log("WOWWWWWW")
        } else if (message.Award !== "") {
          setChips(message.Award);
          setaward(message.Award);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (obj !== undefined) {
      dispatch(generate_my_cv(obj));
    }
  }, [obj])

  // const year =  [];
  //   for(var i = 1998; i <= 2023; i++) {
  //      year.push(`${i}`);
  //   }

    const handleClickOperation = (desiredKey) => {
      let a = award;
      let desiredObject = a.find((item) => item.key === desiredKey.key);
      let w = a.filter(chip => chip.key !== desiredObject.key);
      
      $('[name="award_name"]').val(desiredObject.Award_name);
      $('[name="award_giver"]').val(desiredObject.Award_giver);
      $('[name="r_year"]').val(desiredObject.Award_year);
      
      const startYear = desiredObject.Award_year;
      const firstYear = new Date(startYear);
      let y = firstYear.getTime();
      console.log("Mil year", y);
      setAwardYear(y);
      
      // $('[name="work_place"]').val(desiredObject.Where_i_worked_location);
  
      console.log("desired object", desiredObject);
      w.forEach((element) => {
          element.key = w.indexOf(element);
          console.log("award key", w.indexOf(element));
      });
      setaward(w);
        setChips(w);
        dispatch(dispatchAward(w));
        desiredObject = [];
  
        console.log("inner chips", chips);
        console.log("inner award", w);
    }
  
    // handleClick function
    const handleClick = (desiredKey) => {
      const awrd = $('[name="award_name"]').val();
      if (awrd !== "") {
          handleAdd(); // add already mapped values back to the work array if the client/user forget to click add, this is so, so as to save users experience.
          handleClickOperation(desiredKey);
      } else {
          handleClickOperation(desiredKey);
      }
    }
  
    const handleDelete = (chipToDelete) => {
      const newawd = award.filter(element => {
          if (element.key !== chipToDelete.key)
              return element;
      })
      console.log("new award", newawd);
      newawd.forEach((element) => {
          element.key = newawd.indexOf(element);
      })
      setaward(newawd);
      setChips(newawd);
      dispatch(dispatchAward(newawd));
      console.log("chips", chips);
      console.log("delete cert", award);
    }
  

    const handleAdd = () => {
      if ($('[name="award_name"]').val() === "") {
        setTimeout(() => {
          toast.success("Add award", {
              position: toast.POSITION.TOP_RIGHT,
          });
      }, 50)
      } else {
        const date2 = new Date(awardYear);
  
        const year1 = date2.getFullYear();
  
              const newAwd = award;
              let k = award.length;
              const data =  {
                      key : k,
                      Award_name:  $('[name="award_name"]').val(),
                      Award_giver :  $('[name="award_giver"]').val(),
                      Award_year : year1, 
              }
                newAwd.push(data);
                setaward(newAwd);
                setChips(newAwd);
                dispatch(dispatchAward(newAwd));
                $('[name="award_name"]').val('');
                $('[name="award_giver"]').val('');
                setAwardYear("");
      }
    }   

    const handleNextBtn = () => {
      if (window.location.pathname === `/form/${cv.id}/update`) {
        if ($('[name="award_name"]').val() !== "") {
          handleAdd();
        }
        let generated_value = generated.message;
        generated_value.Award = award;
        setObj(generated_value);
        navigate("/allCv");
      } else {
        if ($('[name="award_name"]').val() !== "") {
          setTimeout(() => {
            toast.error("Add the award you just filled.", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }, 50);
        } else {
          if (award === "") {
            setaward([]);
          }
          if (stat === "false" || stat === false) {
            dispatch(saveAward(award, secret.secret));
          }
          props.handleStepChange();
        }
      }
    }

    const handleBackBtn = () => {
      if ($('[name="award_name"]').val() !== "") {
        setTimeout(() => {
          toast.error("Add the award you just filled.", {
              position: toast.POSITION.TOP_RIGHT,
          });
      }, 50);
      } else {
        props.handleStepChangeBack();
      }
    }

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2 px-3 lg:pl-6">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-normal ">
            {language["complete_award"]}{" "}
            <span className="text-orange-500 text-[14px] md:text-base font-medium">
              {language["skip_quotes"]}{" "}
            </span>
            {language["at_the_bottom"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab
              num="1"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="2"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="3"
              current={false}
              completed={true}
              className="max-[360px]:hidden"
            />
            <Tab
              num="4"
              current={false}
              completed={true}
              className="max-[2800px]:hidden"
            />
            <Tab num="5" current={false} completed={true} />
            <Tab
              // label="Awards and Honors"
              label={`${language["awards_honors"]}`}
              current={true}
              completed={false}
            />
            <Tab num="7" current={false} completed={false} />
            <Tab num="8" current={false} completed={false} />
            <Tab num="9" current={false} completed={false} />
          </div>
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            {/* <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="awardName"
                >
                  What’s the name of the award or honor?
                </label>
              </div>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder="Enter award here"
                id="awardName"
              />
            </div> */}
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="awardTitle"
                >
                  {language["title_award"]}
                </label>
              </div>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder={`${language["award_place"]}`}
                id="awardTitle"
                name="award_name"
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="awardPresenter"
                >
                  {language["who_give_why"]}
                </label>
              </div>
              <input
                type="text"
                className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                placeholder={`${language["enter_place_name"]}`}
                id="awardPresenter"
                name="award_giver"
              />
            </div>

            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="lastName"
                >
                  {language["when_recieve"]}
                </label>
              </div>
              <div className="w-full flex flex-col sm:flex-row gap-2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                  <DatePicker
                      label={`${language["year_place"]}`}
                      views={['year']}
                      value={dayjs(awardYear)}
                      onChange={(event) => setAwardYear(event)}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="flex-col justify-start items-start gap-3 flex w-full">
                <AddMore text="award" onClick={handleAdd} />
                <p className="text-black text-base font-medium">
                  {language["have_added"]}
                </p>
                <div className="flex flex-wrap gap-3">
                  {Array.isArray(chips) === true ? (
                    <>
                      {chips?.map((awd, key) => (
                        <AddedItem
                          item={awd.Award_name}
                          key={key}
                          onClick={() => handleClick(awd)}
                          delete={() => handleDelete(awd)}
                        />
                      ))}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
              <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              onClick={handleBackBtn}>
                <span className="text-center text-orange-500 text-base font-semibold">
                  {language["previous_btn"]}
                </span>
              </button>
              <button
                className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
                onClick={handleNextBtn}
              >
                <span className="text-center text-white text-base font-semibold whitespace-nowrap">
                  {language["save_n_continue"]}
                </span>
              </button>
            </div>
            <button className="flex gap-2 items-center px-5 py-2.5" onClick={props.handleStepChange}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 4C12.5 3.86739 12.4473 3.74021 12.3536 3.64645C12.2598 3.55268 12.1326 3.5 12 3.5C11.8674 3.5 11.7402 3.55268 11.6464 3.64645C11.5527 3.74021 11.5 3.86739 11.5 4V7.248L5.233 3.612C4.713 3.31 4 3.655 4 4.308V11.692C4 12.345 4.713 12.69 5.233 12.388L11.5 8.752V12C11.5 12.1326 11.5527 12.2598 11.6464 12.3536C11.7402 12.4473 11.8674 12.5 12 12.5C12.1326 12.5 12.2598 12.4473 12.3536 12.3536C12.4473 12.2598 12.5 12.1326 12.5 12V4ZM5 4.633L10.804 8L5 11.367V4.633Z"
                  fill="#F24E1E"
                />
              </svg>

              <span className="text-center text-orange-500 text-base font-medium">
                {language["skipstage_noquote"]}
              </span>
            </button>
          </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}